import '../../styles/stock/offer.css';
import bindToForm from '../form/form-protection';
import '../../image/geld-lenen-kost-geld.svg';

function disableSubmitButton(submitButton) {
    submitButton.disabled = true;
    submitButton.innerHTML = '<span class="inline-block animate-spin mr-2">↻</span>Bezig met verzenden...';
}

for (const wizardContainer of document.querySelectorAll('.enable-wizard')) {
    if (wizardContainer.nodeName !== 'FORM') {
        throw new Error('Wizard container must be a form element');
    }

    const buttonContainer = wizardContainer.querySelector('.submit-button-container');
    const submitButton = buttonContainer.querySelector('button[type=submit]');

    wizardContainer.addEventListener('submit', () => {
        disableSubmitButton(submitButton);

        return true;
    });

    // Check if the wizard is enabled
    if (typeof wizardContainer.dataset.wizard !== 'undefined' && wizardContainer.dataset.wizard !== 'true') {
        continue;
    }

    const fakeNextButton = document.createElement('button');
    fakeNextButton.innerText = 'Volgende';

    fakeNextButton.classList.add(...submitButton.classList);
    submitButton.classList.add('hidden');

    const steps = wizardContainer.querySelectorAll('.form-group');
    const errorParentElement = wizardContainer.querySelector('.form-field.error')?.closest('.form-group');

    steps.forEach((el, i) => {
        if (errorParentElement) {
            el.classList.add('hidden');

            if (errorParentElement === el) {
                el.classList.remove('hidden');
            }
        } else {
            i > 0 && el.classList.add('hidden');
        }

        const inputElements = el.querySelectorAll('input, textarea, select');

        if (inputElements.length > 1) {
            return;
        }

        for (const elem of inputElements) {
            elem.addEventListener('keydown', (e) => {
                if (!elem.checkValidity()) {
                    return;
                }

                if (e.key === 'Enter') {
                    e.preventDefault();
                    e.stopPropagation();

                    fakeNextButton.click();
                }
            });
        }
    });

    fakeNextButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const currentStep = wizardContainer.querySelector('.form-group:not(.hidden)');
        const currentInputElement = currentStep.querySelector('input, textarea, select');
        const nextStep = currentStep.nextElementSibling;

        if (!currentInputElement.checkValidity()) {
            currentInputElement.focus();

            return false;
        }

        if (nextStep.classList.contains('form-group')) {
            currentStep.classList.add('hidden');
            nextStep.classList.remove('hidden');
            nextStep.querySelector('input').focus();
        } else {
            disableSubmitButton(fakeNextButton);
            wizardContainer.requestSubmit(submitButton);
        }
    });

    buttonContainer.appendChild(fakeNextButton);
}

for (const formElement of document.querySelectorAll('form[data-protect]')) {
    bindToForm(formElement, 'Weet je zeker dat je de pagina wilt verlaten?');
}

// <editor-fold desc="Mobile view improvements">
const listener = window.matchMedia('(max-width: 768px)');

// Disable the click event of the summary element when the screen is bigger than 640px
document.querySelector('#overview > summary').addEventListener('click', (event) => {
    listener.matches || event.preventDefault();
});

const openSummaryFn = (event) => {
    const overview = document.querySelector('#overview');
    event.matches ? overview.removeAttribute('open') : overview.setAttribute('open', '');
};

listener.addEventListener('change', openSummaryFn);
openSummaryFn(listener);
// </editor-fold>
